export default __webpack_public_path__ + "static/media/record.57dc181a.png";